/**
 * A target in a repeating container is addressable only from the same
 * repeating-container chain. Non-repeating targets are addressable from any
 * current render scope. This compares authored element IDs, not runtime IDs.
 */
export const isOverlayTargetAddressable = ({
  targetProjectingAncestorIds,
  triggerProjectingAncestorIds,
}: {
  targetProjectingAncestorIds: readonly string[];
  triggerProjectingAncestorIds: readonly string[];
}): boolean =>
  targetProjectingAncestorIds.length === 0 ||
  (targetProjectingAncestorIds.length === triggerProjectingAncestorIds.length &&
    targetProjectingAncestorIds.every(
      (id, index) => id === triggerProjectingAncestorIds[index]
    ));
